// 我的资产
<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block" v-loading="Loading">
      <div class="top-title">我的资产</div>
      <choose-search @handleQuery="changeQuery"></choose-search>
      <div class="table">
        <el-table class="financial-services-table" :data="tableData" v-loading="Loading" :header-cell-style="{
            textAlign: 'center',
            background: '#FAFAFA',
            color: '#3F434B',
          }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="name" label="标的名称"></el-table-column>
          <el-table-column prop="areaConfigName" label="区域"></el-table-column>
          <el-table-column prop="businessTypeDesc" label="业务类型"></el-table-column>
          <el-table-column label="投资人类型">
            <template slot-scope="scope">{{
              scope.row.userType == 1
                ? '个人'
                : scope.row.userType == 2
                ? '企业'
                : scope.row.userType == 3
                ? '组织':''
            }}</template>
          </el-table-column>
          <el-table-column prop="transactionPrice" label="成交价款（元）"></el-table-column>
          <el-table-column prop="date" label="成交时间" width="180">
            <template slot-scope="scope">{{
              scope.row.delistingTime
            }}</template>
          </el-table-column>
          <el-table-column label="资产状态">
             <template slot-scope="scope">
              <span>
              {{scope.row.status == 3 ? '挂牌中' : scope.row.status == 6 ? '已成交' : scope.row.status == 5 ? '未成交' : scope.row.status == 4 || scope.row.status == 10 ? '已摘牌' : scope.row.status == 11 ? '已交易' : scope.row.status == 12 ? '交易完成' :scope.row.status == 13 ? '交易取消' :'--' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="incoming_account" label="操作">
            <template slot-scope="scope">
              <div :class="{ blueC: scope.row.acStatus == -1 }" @click="scope.row.acStatus == -1 && showEvt(scope.row.id)">
                申请交易鉴证书
              </div>
              <!-- 资产状态是 已成交，并且 交易鉴证书状态是 已发放，才可以申请贷款 -->
             <div :class="{ blueC: scope.row.maStatus == null }" v-if="scope.row.acStatus == 1" @click="gotoCompanyLoan(scope.row)">
                {{scope.row.maStatus == null?'申请贷款':'已申请贷款'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receivables_name" label="交易鉴证书状态">
            <!-- -1 未申请   0  待发放  1 已发放  2  已抵押 3 已还清 4 已解押 applyVersion //申请版本  1 电子版  2  纸质版-->
            <template slot-scope="scope">
              <span v-if="scope.row.acStatus == -1">未申请</span>
              <span v-else-if="scope.row.acStatus == 0">待发放</span>
              <span class="greenC" v-else-if="scope.row.acStatus == 1" @click="detailUrl(scope.row)">{{
                  scope.row.applyVersion == 1
                    ? '已发放(电子版)'
                    : '已发放(纸质版)'
                }}</span>
              <span v-else-if="scope.row.acStatus == 2">已抵押</span>
              <span v-else-if="scope.row.acStatus == 3">已还清</span>
              <span v-else-if="scope.row.acStatus == 4">已解押</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align: center" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="search.pageNumber" :page-size="search.pageSize" layout="total, prev, pager, next,jumper" :total="total">
        </el-pagination>
      </div>
      <!-- 中止挂牌 -->
      <Dialog :show="diaShow" @dialogClose="diaShow = false" :title="'温馨提示'" :content="'确定申请中止挂牌？'" :btn="'取消'" :btn2="'确定'" />
      <!-- 申请交易鉴证书 -->
      <el-dialog width="30%" title="请选择鉴证书方式" :visible.sync="show" append-to-body :close-on-click-modal="false" v-loading.fullscreen.lock="diaLoading">
        <el-form ref="formRefs" :model="diaFormData" :rules="diaRules" label-width="120px" label-position="left" size="mini">
          <el-radio-group v-model="diaFormData.applyVersion" style="margin: 20px auto; text-align: left; width: 100%">
            <el-radio :label="1">电子版</el-radio>
            <el-radio :label="2">纸质版</el-radio>
          </el-radio-group>
          <el-form-item label="收件人姓名">
            <el-input v-model="diaFormData.receiverName" :disabled="diaFormData.applyVersion == 1" placeholder="请输入收件人姓名">
            </el-input>
          </el-form-item>
          <el-form-item label="收件人联系电话">
            <el-input v-model="diaFormData.receiverPhone" :disabled="diaFormData.applyVersion == 1" @keyup.native="changeCode('receiverPhone')" placeholder="请输入收件人联系电话">
            </el-input>
          </el-form-item>
          <el-form-item label="收件人家庭住址">
            <el-input v-model="diaFormData.receiverAddress" :disabled="diaFormData.applyVersion == 1" placeholder="请输入收件人家庭住址">
            </el-input>
          </el-form-item>
        </el-form>
        <div class="btnDia">
          <el-button @click="diaClose">取消</el-button>
          <el-button @click="diaSubmit" class="btn-2">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ChooseSearch from '@/components/ChooseSearch/index.vue';
import Dialog from '@/components/Dialog';
import publicFunction from '@/utils/publicFunction';
import HeaderImg from '@/components/HeaderImg';
import { sessionStore } from '@/utils/data-management';
import { tableFilter } from '@/views/property-exchange-center/info-collection/tableFilter';
export default {
  components: {
    ChooseSearch,
    Dialog,
    HeaderImg,
  },
  computed: {
    status() {
      return this.$store.state.infoStatus;
    },
  },
  data() {
    return {
      headerList: [{ name: '首页', path: '/Home' }, { name: '我的资产' }],
      diaShow: false,
      show: false,
      Loading: false,
      diaLoading: false,
      tableData: [],
      search: {
        userId: this.$store.state.userInfo.id,
        pageNumber: 1,
        pageSize: 10,
      },
      total: 0,
      diaFormData: {
        // id: '',
        listingApplyId: '', //列表id
        receiverName: '',
        receiverPhone: '',
        receiverAddress: '',
        applyPersonType: 2, //1挂牌方 2摘牌方
        applyVersion: 1, //1电子版 2纸质版
      },
      diaRules: {
        receiverName: [{ required: true, message: '请输入', trigger: 'blur' }],
        receiverPhone: [{ required: true, message: '请输入', trigger: 'blur' }],
        receiverAddress: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    detailUrl(row) {
      sessionStore.set('CertificateDetail', row);
      this.$router.push({
        name: 'myCertificateDetail',
        query: { listSource: 'zc' },
      });
    },
    // 申请贷款按钮 抵押贷款（企业和个人）
    gotoCompanyLoan(val) {
      /**
        acStatus 鉴权证书状态 0  待发放  1 已发放  2  已抵押 3 已还清 4 已解押
        status  摘牌状态 0 竞价中 1 竞价成功（摘牌成功） 2 竞价失败
        maStatus 资产用于抵押后的状态（1：待审批；2：已拒绝；3：待补充资料；4：已通过；5：已还清）
        userType 1 表示个人抵押贷款  2表示企业抵押贷款
        businessType:  业务类型
      */
      if (val.userType == 2) {
        // 企业抵押贷款
        // maStatus 状态，判断该资产是否 已经用于抵押贷款
        // maStatus 状态（1：待审批；2：已拒绝；3：待补充资料；4：已通过；5：已还清） 及 null
        // if(val.maStatus ==null || val.maStatus==2 || val.maStatus==4 || val.maStatus ==5){
        if (val.maStatus == null) {
          if (sessionStore.get('companyInfo')) {
            sessionStore.remove('companyInfo');
          }
          if (sessionStore.get('companyInfoUpload')) {
            sessionStore.remove('companyInfoUpload');
          }
          this.$router.push({
            name: 'companyLoanCollection',
            query: {
              demandId: val.id,
              demandName: val.name,
              businessType: val.businessType,
            },
          });
        } else {
          return;
          this.$message(`请进入“我的贷款”列表中查看`);
        }
      } else if (val.userType == 1) {
        if (sessionStore.get('bankId')) {
          sessionStore.remove('bankId');
        }
        // 个人抵押贷款
        // if(val.maStatus ==null || val.maStatus==2 || val.maStatus==4 || val.maStatus ==5){
        if (val.maStatus == null) {
          if (sessionStore.get('personLoanInfo')) {
            sessionStore.remove('personLoanInfo');
          }
          if (sessionStore.get('loanFileList')) {
            sessionStore.remove('loanFileList');
          }
          this.Loading = true;
          this.$api.user
            .getFarmersInfo({
              phone: sessionStore.get('userInfo').phone,
            })
            .then((res) => {
              if (res.code == 1000) {
                // 是否填写完整
                tableFilter(res.data, true);
                // 需要补充资料
                if (this.status != 2 && this.status != 3) {
                  sessionStore.set('loanCollection', val);
                  this.$goTo('infoCollection', { type: '5' });
                  return;
                }
                this.$router.push({
                  name: 'loanCollection',
                  query: {
                    demandId: val.id,
                    demandName: val.name,
                    businessType: val.businessType,
                    userType: val.userType,
                  },
                });
              }
            })
            .finally(() => {
              this.Loading = false;
            });
        } else {
          return;
          this.$message(`请进入“我的贷款”列表中查看`);
        }
      }else {
        this.$message.error('组织类型暂不支持申请抵押贷款')
      }
    },

    showEvt(id) {
      this.diaFormData = {
        listingApplyId: '', //列表id
        receiverName: '',
        receiverPhone: '',
        receiverAddress: '',
        applyPersonType: 2, //1挂牌方 2摘牌方
        applyVersion: 1, //1电子版 2纸质版
      };
      this.diaFormData.listingApplyId = id;
      this.show = true;
    },
    diaClose() {
      this.$refs.formRefs.resetFields();
      this.show = false;
    },
    diaSubmit() {
      if (this.diaFormData.applyVersion == 2) {
        if (!this.diaFormData.receiverName)
          return this.$message.error('请输入姓名');
        if (!this.diaFormData.receiverPhone)
          return this.$message.error('请输入电话');
        if (!this.diaFormData.receiverAddress)
          return this.$message.error('请输入地址');
      }
      this.certificateEvt();
    },
    //申请鉴定书
    certificateEvt() {
      this.diaLoading = true;
      this.$api.my
        .certificate(this.diaFormData)
        .then((res) => {
          if (res.code == 1000) {
            this.show = false;
            this.$message.success('申请成功');
            this.getTransactionList();
          }
        })
        .catch((error) => {
          this.show = false;
        })
        .finally(() => {
          this.diaLoading = false;
        });
    },
    //查询
    changeQuery(query) {
      if (query.chooseValue != 0) {
        this.$set(this.search, 'beginTime', query.chooseValue);
      } else {
        this.$set(this.search, 'beginTime', null);
        delete this.search.beginTime;
      }
      if (query.searchValue) {
        this.$set(this.search, 'name', query.searchValue);
      } else {
        this.$set(this.search, 'name', null);
        delete this.search.name;
      }
      this.search.pageNumber = 1;
      this.getTransactionList();
    },
    getTransactionList() {
      this.Loading = true;
      let data = JSON.parse(JSON.stringify(this.search));
      Object.keys(data).forEach(function (key) {
        if (data[key] === '') {
          delete data[key];
        }
      });
      this.$api.my
        .pageMyAssetsList(data)
        .then((res) => {
          if (res.code == 1000) {
            this.tableData = [];
            this.tableData = res.data;
            this.total = res.total;
          } else {
            this.$message.error(response.message);
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.Loading = false;
        });
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.getTransactionList();
    },
    dialogSumbitL() {
      this.diaShow = false;
    },
    dialogSumbitR() {
      this.diaShow = false;
    },
    changeCode(name) {
      this.$nextTick(() => {
        if (this.diaFormData[`${name}`] != null) {
          this.diaFormData[`${name}`] = this.diaFormData[`${name}`].replace(
            /[^\d.]/g,
            ''
          );
        }
      });
    },
  },
  mounted() {
    this.getTransactionList();
  },
};
</script>
